import { useMemo } from "react";

import { useTheme } from "@mui/material/styles";

import darkEmptyImg from "@/assets/empty_dark.png";
import lightEmptyImg from "@/assets/empty_light.png";

const useThemeData = () => {
  const theme = useTheme();

  const themeData = useMemo(() => {
    const isDarkMode = theme.palette.mode === "dark";

    return {
      ...theme,
      isDarkMode,
      emptyBg: isDarkMode ? darkEmptyImg : lightEmptyImg,
    };
  }, [theme]);

  return themeData;
};

export default useThemeData;
